/**
 * Define a route.
 *
 * @param route - The route definition.
 * @returns The route definition.
 * @__NO_SIDE_EFFECTS__
 */
export function defineRoute(route) {
    const routeLocationFactory = (options) => {
        if (!options) {
            return { name: route.name };
        }
        const { $query: query, $force: force, ...params } = options;
        return {
            name: route.name,
            params: params,
            query,
            force,
        };
    };
    const routeDefinition = routeLocationFactory;
    routeDefinition.route = route;
    return routeDefinition;
}
//# sourceMappingURL=defineRoute.js.map